import _ from 'lodash';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { Box } from '@mui/system';
import Avatar from '@mui/material/Avatar';
import { Typography } from '@mui/material';
import { unicodeToString } from '../../../../Js/Common';

const pathToParentMenu = ['root'];

const WwAvtar = (props) => {
    return (
        <Grid container sx={{textAlign: 'center'}}>
            <Grid item xs={12}>
                { props.avatarText &&   
                    <Avatar sx={{ width: 34, height: 34,  background: '#fff', border: '1px solid #8E8E8E', mt:1, mb:1, marginLeft: '-0.5px', justifyContent: 'center' ,'@media (min-width: 1636px)':{ width: 50, height: 50}}} >
                        <Typography variant="body1" sx={{color:'primary.main','@media (min-width: 1636px)':{fontSize: '2rem'}}}>
                        <div id={props.data.myId.self} dangerouslySetInnerHTML={{__html: unicodeToString(props.data.source)}} style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}></div>
                        </Typography>
                    </Avatar>
                }
                { props.avatarImg &&
                    <Avatar sx={{ width: 34, height: 34,  background: '#fff', border: '1px solid #8E8E8E', mt:1, mb:1, marginLeft: '-0.5px','@media (min-width: 1636px)':{ width: 50, height: 50}}} >
                        <img src={`${sessionStorage.getItem('media_url')}image/${props.data.source}`} width='100%' style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}/>
                    </Avatar> 
                }
            </Grid>
        </Grid>
    )
}

export default WwAvtar;
